import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  GET_SERVICES,
  CREATE_SERVICES,
  DELETE_SERVICES,
  UPDATE_SERVICES,
} from "./actionType";

import { ServicesApiResponseSuccess, ServicesApiResponseError } from "./action";

import {
  getServices as servicesGet,
  createServices as servicesCreate,
  updateServices as servicesUpdate,
  deleteServices as servicesDelete,
} from "../../helpers/backend_helper";
import { notifyError, notifySuccess } from "../../components/notify";

function* getServices() {
  try {
    const response = yield call(servicesGet);
    yield put(ServicesApiResponseSuccess(GET_SERVICES, response));
  } catch (error) {
    yield put(ServicesApiResponseError(GET_SERVICES, error));
  }
}

function* createServices(data) {
  const { payload } = data;
  try {
    const response = yield call(servicesCreate, payload.data);
    yield put(ServicesApiResponseSuccess(CREATE_SERVICES, response));
    notifySuccess("Serviço criado com sucesso!");
  } catch (error) {
    yield put(ServicesApiResponseError(CREATE_SERVICES, error));
    notifyError("Erro ao criar serviço!");
  }
}

function* updateServices(data) {
  try {
    const response = yield call(servicesUpdate, {
      id: data.payload.id,
      data: data.payload.data,
    });
    yield put(ServicesApiResponseSuccess(UPDATE_SERVICES, response));
    notifySuccess("Serviço atualizado com sucesso!");
  } catch (error) {
    yield put(ServicesApiResponseError(UPDATE_SERVICES, error));
    notifyError("Erro ao atualizar serviço!");
  }
}

function* deleteServices(data) {
  try {
    const response = yield call(servicesDelete, data.payload.id);
    yield put(ServicesApiResponseSuccess(DELETE_SERVICES, response));
    notifySuccess("Serviço deletado com sucesso!");
  } catch (error) {
    yield put(ServicesApiResponseError(DELETE_SERVICES, error));
    notifyError("Erro ao deletar serviço!");
  }
}

export function* watchGetServices() {
  yield takeEvery(GET_SERVICES, getServices);
}

export function* watchCreateServices() {
  yield takeEvery(CREATE_SERVICES, createServices);
}

export function* watchUpdateServices() {
  yield takeEvery(UPDATE_SERVICES, updateServices);
}

export function* watchDeleteServices() {
  yield takeEvery(DELETE_SERVICES, deleteServices);
}

function* ServicesSaga() {
  yield all([fork(watchGetServices)]);
  yield all([fork(watchCreateServices)]);
  yield all([fork(watchUpdateServices)]);
  yield all([fork(watchDeleteServices)]);
}

export default ServicesSaga;
